import api from '@/api';

export default {
    namespaced: true,
    state: {
        settings: {
            siteName: 'منصة الرحيمة',
            siteDescription: 'منصة إسلامية شاملة للتعليم والإرشاد',
            contactEmail: 'info@alrahima.com',
            contactPhone: '+966 50 123 4567',
            socialFacebook: 'https://facebook.com',
            socialWhatsapp: '966501234567',
            socialInstagram: 'https://instagram.com',
            socialYoutube: 'https://youtube.com',
            socialTiktok: 'https://tiktok.com',
            footerDescription: 'منصة تعليمية إسلامية تهدف إلى نشر القرآن الكريم والعلم الشرعي والمحتوى الهادف بأسلوب بسيط يتناسب مع كل الفئات مع الإلتزام التام بالهوية الإسلامية.',
            address: 'السودان',
            maintenanceMode: false,
            showRamadanMode: true,
        },
        isLoaded: false
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            const booleanKeys = ['allowComments', 'moderateComments', 'allowRegistration', 'twoFactorAuth', 'activityLogging', 'maintenanceMode', 'showRamadanMode'];
            const processedSettings = { ...settings };

            Object.keys(processedSettings).forEach(key => {
                if (booleanKeys.includes(key)) {
                    if (processedSettings[key] === 'true') processedSettings[key] = true;
                    if (processedSettings[key] === 'false') processedSettings[key] = false;
                }
                // Also handle numbers if necessary
                if (key === 'maxLoginAttempts' || key === 'smtpPort') {
                    processedSettings[key] = Number(processedSettings[key]);
                }
            });

            state.settings = { ...state.settings, ...processedSettings };
            state.isLoaded = true;
        }
    },
    actions: {
        async fetchPublicSettings({ commit }) {
            try {
                const response = await api.get('/admin/public-settings', { _silent: true });
                commit('SET_SETTINGS', response.data);
            } catch (error) {
                console.error('Error fetching public settings:', error);
            }
        },
        async fetchAllSettings({ commit }) {
            try {
                const response = await api.get('/admin/settings', { _silent: true });
                commit('SET_SETTINGS', response.data);
            } catch (error) {
                console.error('Error fetching all settings:', error);
            }
        },
        async updateSettings({ commit }, settings) {
            try {
                await api.put('/admin/settings', settings);
                commit('SET_SETTINGS', settings);
                return true;
            } catch (error) {
                console.error('Error updating settings:', error);
                throw error;
            }
        }
    },
    getters: {
        getSettings: (state) => state.settings,
        isLoaded: (state) => state.isLoaded
    }
};
